import React from 'react';
import { CheckCircle2, XCircle, Calendar } from 'lucide-react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '@/components/ui/dialog';
import { formatAbs } from './utils';

const EmailDetailDialog = ({ detailRow, onClose }) => {
  return (
    <Dialog open={!!detailRow} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="bg-[#0F1730] border-[#2A3658] max-w-2xl"
        data-testid="email-activity-detail-dialog"
      >
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            {detailRow?.success ? (
              <CheckCircle2 className="h-5 w-5 text-emerald-400" />
            ) : (
              <XCircle className="h-5 w-5 text-red-400" />
            )}
            Email details
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            Read-only inspection of a single SendGrid send.
          </DialogDescription>
        </DialogHeader>
        {detailRow && (
          <div className="space-y-3 text-sm">
            <div>
              <div className="text-xs uppercase text-slate-500">Subject</div>
              <div className="text-slate-100 mt-1">{detailRow.subject || '(no subject)'}</div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <div className="text-xs uppercase text-slate-500">Recipient</div>
                <div className="text-amber-300 mt-1 font-mono text-xs">{detailRow.to}</div>
              </div>
              <div>
                <div className="text-xs uppercase text-slate-500">Category</div>
                <div className="text-slate-100 mt-1">{detailRow.category}</div>
              </div>
              <div>
                <div className="text-xs uppercase text-slate-500">Status code</div>
                <div className="text-slate-100 mt-1 font-mono">{detailRow.status_code ?? '—'}</div>
              </div>
              <div>
                <div className="text-xs uppercase text-slate-500">Result</div>
                <div className={`mt-1 ${detailRow.success ? 'text-emerald-400' : 'text-red-400'}`}>
                  {detailRow.success ? 'Delivered' : 'Failed'}
                </div>
              </div>
            </div>
            <div>
              <div className="text-xs uppercase text-slate-500 flex items-center gap-1">
                <Calendar className="h-3 w-3" /> Sent at
              </div>
              <div className="text-slate-100 mt-1 font-mono text-xs">
                {formatAbs(detailRow.sent_at)}
              </div>
            </div>
            {detailRow.error && (
              <div>
                <div className="text-xs uppercase text-slate-500">Error</div>
                <pre
                  className="bg-red-950/30 border border-red-800/40 text-red-200 text-xs p-2 rounded mt-1 whitespace-pre-wrap break-all"
                >{detailRow.error}</pre>
              </div>
            )}
            <div className="text-xs text-slate-500 pt-2 border-t border-[#2A3658]">
              This view is read-only. To re-send, trigger the underlying
              event (e.g. resubscribe, re-invite) — no resend button by
              design to prevent accidental SendGrid credit usage.
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EmailDetailDialog;
